// extracted by mini-css-extract-plugin
export default {"icon":"benefits_icon__iBgDW","card":"benefits_card__mIu2Z","transparent":"benefits_transparent__BRtPF","image":"benefits_image__BXVbU","Button":"benefits_Button__bFvsh"};